module.exports = __webpack_public_path__ + "img/csa_button_mini_games.8697a97e.png";